import React from 'react';
import PropTypes from 'prop-types';
import { useDispatch, useSelector } from 'react-redux';
import { setPageNumber, setRowsPerPage } from '../../action/searchFilterAction';
import TablePaginationActions from "./helper/TablePagination";
import { PAGINATION_DEFAULT_ROWS_PER_PAGE, PAGINATION_ROWS_PER_PAGE_OPTION } from "../../utils/constants";
import { Box, TablePagination } from "@mui/material";

const CustomPagination = ({ count, rowsPerPageOptions = PAGINATION_ROWS_PER_PAGE_OPTION }) => {
  const dispatch = useDispatch();
  const pageNumber = useSelector((state) => state.searchFilter.pageNumber || 1);
  const rowsPerPage = useSelector((state) => state.searchFilter.rowsPerPage) || PAGINATION_DEFAULT_ROWS_PER_PAGE;
  const zeroBasedPage = pageNumber - 1;

  const handlePageChange = (event, newPage) => {
    dispatch(setPageNumber(newPage + 1));
  };

  const handleChangeRowsPerPage = (event) => {
    const newRowsPerPage = parseInt(event.target.value, 10);
    dispatch(setRowsPerPage(newRowsPerPage));
    dispatch(setPageNumber(1));
  };

  const paginatedFrom = (pageNumber - 1) * rowsPerPage + 1;
  const paginatedTo = Math.min(pageNumber * rowsPerPage, count);

  return (
    <> {count > 0 &&
      <Box className="print-none">
        <TablePagination
          component="div"
          count={count}
          page={zeroBasedPage}
          onPageChange={handlePageChange}
          rowsPerPage={rowsPerPage}
          onRowsPerPageChange={handleChangeRowsPerPage}
          ActionsComponent={TablePaginationActions}
          rowsPerPageOptions={rowsPerPageOptions}
          labelDisplayedRows={() => `${paginatedFrom}-${paginatedTo} of ${count}`}
        />
      </Box>
    }
    </>
  );
};

CustomPagination.propTypes = {
  count: PropTypes.number,
  rowsPerPageOptions: PropTypes.arrayOf(PropTypes.number),
};

export default CustomPagination;
